import * as React from 'react'
import { Settings } from '../../services/AppSettingsService';
import { queryNoTracking } from '../../services/DataService';
import { accentUtils, def, from } from '../../services/HelperService';
import { AccentSpinner } from '../AccentSpinner';
import { AccentComboUnbound } from '../unbound/AccentComboUnbound';


const query_DocumentTemplate_Select = queryNoTracking("DocumentTemplate_Select");

export const DocumentTemplateSelection = props => {

    const [defaultValue, setDefaultValue] = React.useState(def(props.defaultValue, Settings.GetAppSettings()[`Default${props.type}DocumentTemplate`]));
    const [data, setData] = React.useState(null);

    const onChanged = React.useCallback(e => {

        var item = from(data).where(x => x.ID == e).firstOrDefault();

        props.onChange({ ...item  });

        const v = {};
        v[`Default${props.type}DocumentTemplate`] = e;

        Settings.SetAppSettings(v);

    }, [props, data]);


    React.useEffect(e => {

        query_DocumentTemplate_Select.getAllWithCache({type: props.type}).then(r => {


            const possibleDefault = from(r).firstOrDefault(i => i.ID == defaultValue);

            if (r.length == 1 && (accentUtils.isEmpty(defaultValue) || !possibleDefault)) {
                const singleTemplate = r[0];
                setDefaultValue(singleTemplate?.ID);
                onChanged(singleTemplate?.ID);
                setData(r);
                if (props.onReady) props.onReady(singleTemplate);
            } else {
                setData(r);
                if (props.onReady) props.onReady(possibleDefault);
            }


        });

    }, []);


    if (data == null) return <AccentSpinner />;

    return <AccentComboUnbound displayField="Name" required={props.required} valueField="ID" defaultValue={defaultValue} onChange={onChanged} label="Document Template" data={data} />;

};